module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_6_1.fb574210.jpeg";